import { render, staticRenderFns } from "./AdminCommonRatingTable.vue?vue&type=template&id=5beb846a&"
import script from "./AdminCommonRatingTable.vue?vue&type=script&lang=js&"
export * from "./AdminCommonRatingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports